module.exports = __webpack_public_path__ + "static/img/qualifications_row_17.154e517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_17.png
// module id = 1tsj
// module chunks = 1